export default "https://assets.egbcdn.net/assets/packs/_/images/referrals/devices_mobile-2c898260600f8d3a9042edfc6150c0ec.png";